import { HistoricalMovement } from './historical-movement';

export class HistoricalMovements {

  constructor(
    public historicalMovements?: HistoricalMovement[],
    public totalPage?: number,
    public total?: number
  ) { }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/historical-movements.ts